<template>
  <div id="costumerACS">
    <div class="row py-3 px-3">
      <h1 class="text-title text-white mt-4 mb-4">Our Projects</h1>
      <div
        id="Costumercarousel"
        class="carousel body-carousel slide mb-5"
        data-bs-ride="carousel"
      >
        <ol class="carousel-indicators">
          <template v-for="(ct, key) in contents">
        <button type="button" data-bs-target="#Costumercarousel" :data-bs-slide-to="key" :class="{ active: key === 0 }" :key="key" aria-current="true"></button>
          </template>
        </ol>
        <div class="c mt-2 mb-5 ms-5">
          <template v-for="(ct, key) in contents">
            <div class="carousel-item Csadofa-image" :class="{ active: key === 0 }" :key="key">
              <div class="container">
                <div class="row">
                  <div class="card-group">
                    <div class="col-sm-3 col-md-4 d-flex justify-content-end">
                      <div id="cardCostumer1" class="card w-75 py-1 px-1">
                        <img :src="ct.logo_url" class="card-img-top w-75 border border-0 rounded mx-auto d-block"/>
                        <div class="card-body py-3 px-3">
                          <h6 class="card-title text-dark text-center">
                            {{ ct.namacostumer }}
                          </h6>
                          <p class="card-text text-dark text-center">
                            {{ ct.story }}
                          </p>
                          <p class="card-text text-dark text-center">
                            <small class="text-muted mb-2">August 2021</small>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-7 col-md-8 d-flex justify-content-center">
                      <div id="cardCostumer2" class="card-img-top-250 w-75">
                        <img :src="ct.imgProjectacs" class="img-thumbnail" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
          <button class="carousel-control-prev" type="button" data-bs-target="#Costumercarousel" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </button>
          <button class="carousel-control-next" type="button" data-bs-target="#Costumercarousel" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CostumerAdofa",
  data: () => ({
    contents: [
      {
        logo_url: "img/garudafood300.png",
        namacostumer: "PT Garuda Food",
        story: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        imgProjectacs: "img/mondeles-forkorder.png",
      },
      {
        logo_url: "img/mondeles300.png",
        namacostumer: "PT Mondelez International",
        story: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        imgProjectacs: "img/mondeles-forkorder.png",
      },
      {
        logo_url: "img/PT Amerta Indah Otsuka300.png",
        namacostumer: "PT Amerta Indah Otsuka",
        story: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        imgProjectacs: "img/mondeles-forkorder.png",
      },
    ],
  }),
};
</script>

<style>
/* .card-deck .card1 .card {
  margin-left: 100%;
} */
/* #costumerACS .bg {
  margin-right: -30px;
  margin-left: -30px;
  padding-bottom: 3rem !important;
  padding-top: 3rem !important;
  background: #000000;
  height: 500px;
  clip-path: polygon(0 0, 100% 10%, 100% 100%, 0 90%);
} */

#Costumercarousel #cardCostumer1 {
}
#Costumercarousel #cardCostumer2 {
}
#costumerACS .text-title {
  font-size: 48px;
  font-weight: bolder;
}

@media screen and (max-width: 640px) {
  #costumerACS .row .text-title {
    font-size: 26px;
  }
  #Costumercarousel #cardCostumer1 {
    margin-left: -15%;
  }
  #Costumercarousel #cardCostumer1 .card-img-top {
    width: 25%;
    height: 40%;
  }
  #Costumercarousel .card-deck #cardCostumer1 .card-body .card-title {
    font-size: 14px;
  }
  #Costumercarousel .card-deck #cardCostumer1 .card-body .card-text {
    font-size: 10px;
  }
  #Costumercarousel .card-deck #cardCostumer1 .card-body .card-text .text-muted {
    font-size: 8px;
  }
  #Costumercarousel #cardCostumer2 {
    margin-left: -15%;
  }
}
</style>
